export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar conta do oferente"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conta do oferente"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}